import React from 'react';
import styled from 'styled-components';
import {R6No1, R6No2, R6No3, R6No4, R6No5} from '../Sound/index';

const HeadingColor = styled.h6`
    color: #00ad80;
    font-weight: bold;
`;
const NoDownload = 'nodownload';

let audio ="";
const AudioPlayer = props => {
    // 値によって判断する
    switch (props.playNumber) {
        case '1':
            audio = R6No1;
            break;
        case '2':
            audio = R6No2;
            break;
        case '3':
            audio = R6No3;
            break;
        case '4':
            audio = R6No4;
            break;
        case '5':
            audio = R6No5;
            break;
        // case '6':
        //     audio = R6No6;
        //     break;
    
        default:
            break;
    }
    return (
        <>
        {
            props.playNumber!==false &&
            <>
            <HeadingColor>2024年&ensp;第{props.playNumber}回英語リスニング音声</HeadingColor>
            <audio style={{width:'100%'}} src={audio} preload="none" controls="controls" controlsList={NoDownload}></audio>
            </>
        }  
        {
            props.playNumber===false &&
            <>
            <HeadingColor>2024年&ensp;第1回英語リスニング音声</HeadingColor>
            <audio src={R6No1} preload="none" controls="controls" controlsList={NoDownload}></audio>
            </>
        }  
        </>
    );
}

export default AudioPlayer;